import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ErrorBoundary } from '@parkify/ui/error-boundary'
import App from './App'
import { DEMO, installDemo } from './demo'
import '@parkify/brand-tokens/tokens.css'
import './styles.css'

// Sales demo mode (VITE_DEMO=1 builds only). Seeds a signed-in tenant session
// + a fetch interceptor before mount, so App renders as if a real magic link
// had just been redeemed. `DEMO` constant-folds to false and this whole
// branch (plus src/demo/*) dead-code-eliminates in the real production build.
// See src/demo/index.ts.
if (DEMO) installDemo()

const GOOGLE_CLIENT_ID = import.meta.env.VITE_AUTH_GOOGLE_CLIENT_ID as string | undefined
const STAGING = import.meta.env.VITE_STAGING === '1'

// Root error boundary (parity with parkify-demo#91): a render error anywhere
// below shows a fallback card with a reload action instead of unmounting the
// whole tree and leaving a blank page.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary label="tenant-portal">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || 'unconfigured.apps.googleusercontent.com'}>
        {STAGING && <div role="status" style={{ position: 'relative', zIndex: 1000, background: '#2d1140', color: '#fff', textAlign: 'center', padding: '6px 12px', fontSize: 12, fontWeight: 800, letterSpacing: 1 }}>STAGING · TEST DATA</div>}
        <App />
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
